import { Flex, Spinner, Text } from "@chakra-ui/react"
import { useTranslation } from "react-i18next"

const LocalButtonLoader = ({ enabled }: { enabled: boolean }) => {
  const { t } = useTranslation()
  return (
    <Flex>
      <Text>{enabled ? t("Stopping") : t("Starting")}</Text>{" "}
      <Spinner size="xs" marginLeft={"5px"} />
    </Flex>
  )
}

export default LocalButtonLoader
